<template>
  <div class="wrapper signin__image--bg">
    <section class="signin">
      <div class="signin__image">
        <img src="img/etc/Title.png">
      </div>
      <div class="signin__input">
        <input type="email" pattern="^[a-zA-Z]{1}[0-9a-zA-Z]+[\w\.-]+@[\w\.-]+\.\w{2,}$" v-model="param_login.mailaddress" placeholder="メールアドレスを入力してください" id="mailSignin">
      </div>
      <div class="signin__input">
        <input type="password" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" v-model="param_login.password" placeholder="パスワードを入力してください" id="PassSignin">
      </div>
      <router-link to="remind_password" class="signin__link--forgot">
        <span>パスワードを忘れた場合 ＞</span>
      </router-link>
      <button type="button" class="signin__button" :class="{active: is_active}" @click="login">ログイン</button>
    </section>
  </div>
</template>

<script>
	import { mapState } from 'vuex'

	export default {
		data() {
			return {
				param_login: {
					mailaddress: "",
					password: ""
				},
        param_auto_login: {
          device_id: "",
          login_id: ""
        },
				profile: {
					device_id: "",
					login_id: "",
					trn_user_id: "",
          session_id: null,
          nickname: "",
				},
        is_active: false,
			}
		},
    created() {
      this.$store.commit('loading/setLoadingStatus', false)
    },
    mounted() {
      this.checkAutoLogin()
    },
    methods: {
      checkAutoLogin() {
        NativeStorage.getItem('profile', (value) => {
          this.param_auto_login.device_id = value.device_id
          this.param_auto_login.login_id = value.login_id
          this.profile.device_id = value.device_id
          this.profile.login_id = value.login_id
          this.profile.trn_user_id = value.trn_user_id
          this.autoLogin()
        })
      },
      async login() {
			  if (!this.is_active) {
			    return
        }
        this.$store.commit('loading/setLoadingStatus', true)
        await this.$store.dispatch('authorize/reloginApi', this.param_login)
        if (this.loginApiStatus) {
          if (this.loginUserData.group_data.length > 0) {
            // 不変のユーザーデータはNativeStorageに保持しておく
            this.profile.device_id = this.loginUserData.device_id
            this.profile.login_id = this.loginUserData.login_id
            this.profile.trn_user_id = this.loginUserData.trn_user_id
            this.profile.session_id = this.loginUserData.session_id
            this.profile.nickname = this.loginUserData.nickname
            NativeStorage.setItem("profile", this.profile, null, null);
            await this.$store.dispatch('group/groupApi')
            if (this.groupApiStatus) {
              let default_group_id = null
              let limit_datetime = ""
              this.groupData.filter(item => {
                if (item.default_flg) {
                  default_group_id = item.trn_group_id
                  limit_datetime = item.limit_datetime
                }
              })
              if (default_group_id === null) {
                default_group_id = this.groupData[0].trn_group_id
              }
              let now_date = new Date()
              if (now_date > new Date(limit_datetime)) {
                this.groupTimeOutAlert()
                return
              }
              this.$store.commit('group/setGroupId', default_group_id)
              NativeStorage.setItem('group_id', default_group_id)

              await this.$router.push('calendar')
            }
          }
          else {
            navigator.notification.alert(
                'このアカウントはグループに参加していません。',
                null,
                'エラー',
                'OK'
            )
          }
        }
        this.$store.commit('loading/setLoadingStatus', false)
      },
      async autoLogin() {
        this.$store.commit('loading/setLoadingStatus', true)
        await this.$store.dispatch('authorize/loginApi', this.param_auto_login)
        if (this.loginApiStatus) {
          if (this.loginUserData.group_data.length > 0) {
            this.profile.nickname = this.loginUserData.nickname
            this.profile.session_id = this.loginUserData.session_id
            NativeStorage.setItem("profile", this.profile, null, null);
            await this.$store.dispatch('group/groupApi')
            if (this.groupApiStatus) {
              let default_group_id = null
              let limit_datetime = ""
              this.groupData.filter(item => {
                if (item.default_flg) {
                  default_group_id = item.trn_group_id
                  limit_datetime = item.limit_datetime
                }
              })
              if (default_group_id === null) {
                default_group_id = this.groupData[0].trn_group_id
              }
              let now_date = new Date()
              if (now_date > new Date(limit_datetime)) {
                this.groupTimeOutAlert()
                return
              }
              this.$store.commit('group/setGroupId', default_group_id)
              NativeStorage.setItem('group_id', default_group_id)

              await this.$router.push('calendar')
            }
          }
          else {
            navigator.notification.alert(
                'このアカウントはグループに参加していません。',
                null,
                'エラー',
                'OK'
            )
          }
        }
        this.$store.commit('loading/setLoadingStatus', false)
      },
      groupTimeOutAlert() {
        navigator.notification.alert(
            'グループの期限が切れています。',
            () => { this.$store.commit('loading/setLoadingStatus', false) },
            "",
            "OK"
        )
      },
		},
    watch: {
      param_login: {
        handler(value) {
          this.is_active = value.mailaddress !== "" && value.password.length >= 8
        },
        deep: true,
      }
    },
		computed: {
			...mapState({
				loginApiStatus: state => state.authorize.apiStatus,
				loginUserData: state => state.authorize.userData,
        groupApiStatus: state => state.group.apiStatus,
        groupData: state => state.group.groupData,
			})
		}
  }
</script>
